import React from 'react';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { CurrentUserGq } from '../../../graphql/users/models/CurrentUserGq';
import UserCurrencyForm from './UserCurrencyForm';
import UserLanguageForm from './UserLanguageForm';
import UserLocationForm from './UserLocationForm';
import UserPaletteForm from './UserPaletteForm';

export interface DataSettingsPageProps {
  user: CurrentUserGq;
  reload: () => Promise<any>;
  setLanguageDirty: (dirty: boolean) => void;
  setLanguageSave: (saveFunction: () => Promise<unknown>) => void;
  setLocationDirty: (dirty: boolean) => void;
  setLocationSave: (saveFunction: () => Promise<unknown>) => void;
  setCurrencyDirty: (dirty: boolean) => void;
  setCurrencySave: (saveFunction: () => Promise<unknown>) => void;
  setPaletteDirty: (dirty: boolean) => void;
  setPaletteSave: (saveFunction: () => Promise<unknown>) => void;
}

const DataSettingsPage: React.FC<DataSettingsPageProps> = ({
  user,
  reload,
  setLanguageDirty,
  setLanguageSave,
  setLocationDirty,
  setLocationSave,
  setCurrencyDirty,
  setCurrencySave,
  setPaletteDirty,
  setPaletteSave,
}) => {

  return (
    <div className="flex flex-col gap-4">
      <div className="py-4">
        <VoxelText variant="title2">Data settings</VoxelText>
        <VoxelText variant="bread-normal" paddingTop>
          These settings are your default settings when fetching data or creating a new project in the app, unless overridden by project specific settings.
        </VoxelText>
      </div>
      <div className="flex flex-col gap-8">
        <UserCurrencyForm
          user={user}
          setDirty={setCurrencyDirty}
          setSave={setCurrencySave}
          reload={reload}
        />
        <UserPaletteForm
          user={user}
          setDirty={setPaletteDirty}
          setSave={setPaletteSave}
          reload={reload}
        />
        <UserLanguageForm
          user={user}
          setDirty={setLanguageDirty}
          setSave={setLanguageSave}
          reload={reload}
        />
        <UserLocationForm
          user={user}
          setDirty={setLocationDirty}
          setSave={setLocationSave}
          reload={reload}
        />
      </div>
    </div>
  );
};

export default DataSettingsPage;
